import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="bg-background-200 min-h-screen">
          <div className="w-full max-w-[480px] mx-auto bg-white min-h-screen relative">
            <AppRoutes />
          </div>
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;